export default __webpack_public_path__ + "static/media/computer.884ab8e2.png";